import Utils from "../../../../../shared/utils";

export const IMAGE_URL = Utils.buildProductPageImageLink("mort/success-image.svg")

export const SUCCESS_MESSAGE = `הפרטים נשלחו בהצלחה`